export type LangKey = 'ru' | 'kz' | 'en'

export type TranslationEntry = {
  ru: string
  kz: string
  en: string
}

export type Translations = Record<string, TranslationEntry>

export const translations: Translations = {
  // ── NAV ──
  'nav.about': {
    ru: 'О компании',
    kz: 'Компания туралы',
    en: 'About',
  },
  'nav.services': {
    ru: 'Услуги',
    kz: 'Қызметтер',
    en: 'Services',
  },
  'nav.experience': {
    ru: 'Опыт',
    kz: 'Тәжірибе',
    en: 'Experience',
  },
  'nav.facilities': {
    ru: 'Объекты',
    kz: 'Нысандар',
    en: 'Facilities',
  },
  'nav.approach': {
    ru: 'Подход',
    kz: 'Тәсіл',
    en: 'Approach',
  },
  'nav.advantages': {
    ru: 'Преимущества',
    kz: 'Артықшылықтар',
    en: 'Advantages',
  },
  'nav.faq': {
    ru: 'FAQ',
    kz: 'FAQ',
    en: 'FAQ',
  },
  'nav.contact': {
    ru: 'Контакты',
    kz: 'Байланыс',
    en: 'Contact',
  },

  // ── HERO ──
  'hero.headline': {
    ru: 'Автоматизация и инженерные решения',
    kz: 'Автоматтандыру және инженерлік шешімдер',
    en: 'Automation & Engineering Solutions',
  },
  'hero.subheadline': {
    ru: 'ПЛК, SCADA, электромонтаж, КИПиА, слаботочные системы и пусконаладочные работы',
    kz: 'ПЛК, SCADA, электр монтажы, бақылау-өлшеу құралдары және автоматика, төмен вольтты жүйелер, іске қосу-баптау жұмыстары',
    en: 'PLC, SCADA, electrical installation, instrumentation and automation, low-voltage systems, and commissioning works',
  },
  'hero.cta.primary': {
    ru: 'Запросить консультацию',
    kz: 'Кеңес сұрау',
    en: 'Request Consultation',
  },
  'hero.cta.secondary': {
    ru: 'Получить коммерческое предложение',
    kz: 'Коммерциялық ұсыныс алу',
    en: 'Get Commercial Proposal',
  },
  'hero.credibility': {
    ru: '35+ лет совокупного инженерного опыта',
    kz: '35+ жыл жиынтық инженерлік тәжірибе',
    en: '35+ years of combined engineering experience',
  },

  // ── TRUST STRIP ──
  'trust.experience.number': { ru: '35+', kz: '35+', en: '35+' },
  'trust.experience.label': {
    ru: 'Лет совокупного опыта',
    kz: 'Жыл жиынтық тәжірибе',
    en: 'Years Combined Experience',
  },
  'trust.geography.label': {
    ru: 'Работа по всему Казахстану',
    kz: 'Бүкіл Қазақстан бойынша жұмыс',
    en: 'Work Across Kazakhstan',
  },
  'trust.compliance.label': {
    ru: 'Соответствие СНиП, СП РК, ПУЭ',
    kz: 'ҚНжЕ, СП РК, ПУЭ сәйкестігі',
    en: 'SNIP, SP RK, PUE Compliance',
  },
  'trust.quality.label': {
    ru: 'Контроль качества на каждом этапе',
    kz: 'Әр кезеңде сапа бақылауы',
    en: 'Quality Control at Every Stage',
  },

  // ── ABOUT ──
  'about.label': {
    ru: 'О компании',
    kz: 'Компания туралы',
    en: 'About the Company',
  },
  'about.heading': {
    ru: 'Power Logic Automation LLP',
    kz: 'Power Logic Automation ЖШС',
    en: 'Power Logic Automation LLP',
  },
  'about.p1': {
    ru: 'Power Logic Automation LLP — инженерная компания, работающая на территории Республики Казахстан. Компания специализируется на промышленной автоматизации, системах КИПиА, электромонтажных работах, а также строительно-монтажных работах.',
    kz: 'Power Logic Automation ЖШС — Қазақстан Республикасы аумағында жұмыс істейтін инженерлік компания. Компания өнеркәсіптік автоматтандыруға, КИП және А жүйелеріне, электр монтаж жұмыстарына, сондай-ақ құрылыс-монтаж жұмыстарына маманданған.',
    en: 'Power Logic Automation LLP is an engineering company operating in the Republic of Kazakhstan. The company specializes in industrial automation, instrumentation systems (I&C), electrical installation works, and construction & installation support.',
  },
  'about.p2': {
    ru: 'Команда обладает совокупным профессиональным опытом более 35 лет, полученным на крупных промышленных предприятиях. Компания расширяет материально-техническую базу и формирует сеть поставщиков и партнёров.',
    kz: 'Команда ірі өнеркәсіптік кәсіпорындарда алынған 35 жылдан астам жиынтық кәсіби тәжірибеге ие. Компания материалдық-техникалық базасын кеңейтіп, жеткізушілер мен серіктестер желісін қалыптастыруда.',
    en: 'The team has more than 35 years of combined professional experience gained at major industrial enterprises. The company is expanding its material and technical base and building a network of suppliers and partners.',
  },
  'about.highlight.engineering': {
    ru: 'Инженерная направленность',
    kz: 'Инженерлік бағыт',
    en: 'Engineering-Driven',
  },
  'about.highlight.engineering.desc': {
    ru: 'Компания с инженерным фокусом и техническим подходом к каждому проекту',
    kz: 'Әр жобаға инженерлік бағыт пен техникалық тәсіл',
    en: 'Company with engineering focus and technical approach to every project',
  },
  'about.highlight.compliance': {
    ru: 'Соответствие СНиП, СП РК, ПУЭ',
    kz: 'ҚНжЕ, СП РК, ПУЭ сәйкестігі',
    en: 'SNIP, SP RK, PUE Compliance',
  },
  'about.highlight.compliance.desc': {
    ru: 'Все работы выполняются в соответствии с действующими нормативными документами',
    kz: 'Барлық жұмыстар қолданыстағы нормативтік құжаттарға сәйкес орындалады',
    en: 'All works performed in accordance with applicable regulatory documents',
  },
  'about.highlight.safety': {
    ru: 'Промышленная безопасность',
    kz: 'Өнеркәсіптік қауіпсіздік',
    en: 'Industrial Safety',
  },
  'about.highlight.safety.desc': {
    ru: 'Соблюдение требований промышленной безопасности на всех этапах работ',
    kz: 'Жұмыстың барлық кезеңдерінде өнеркәсіптік қауіпсіздік талаптарын сақтау',
    en: 'Compliance with industrial safety requirements at all stages of work',
  },
  'about.highlight.quality': {
    ru: 'Контроль качества',
    kz: 'Сапа бақылауы',
    en: 'Quality Control',
  },
  'about.highlight.quality.desc': {
    ru: 'Поэтапный контроль качества выполняемых работ',
    kz: 'Орындалатын жұмыстардың кезеңді сапа бақылауы',
    en: 'Stage-by-stage quality control of all performed works',
  },

  // ── SERVICES ──
  'services.label': {
    ru: 'Услуги',
    kz: 'Қызметтер',
    en: 'Services',
  },
  'services.heading': {
    ru: 'Направления деятельности',
    kz: 'Қызмет бағыттары',
    en: 'Our Services',
  },
  'services.subtitle': {
    ru: 'Полный комплекс работ по промышленной автоматизации, электромонтажу и слаботочным системам',
    kz: 'Өнеркәсіптік автоматтандыру, электр монтажы және әлсіз токты жүйелер бойынша жұмыстардың толық кешені',
    en: 'Full range of industrial automation, electrical installation, and low-current system services',
  },

  // Service Category 1: Industrial Automation & Instrumentation
  'services.automation.title': {
    ru: 'Автоматизация и КИПиА',
    kz: 'Автоматтандыру және КИП және А',
    en: 'Automation & Instrumentation',
  },
  'services.automation.item1': {
    ru: 'Монтаж датчиков давления, температуры и уровня',
    kz: 'Қысым, температура және деңгей датчиктерін монтаждау',
    en: 'Installation of pressure, temperature, and level sensors',
  },
  'services.automation.item2': {
    ru: 'Монтаж исполнительных механизмов',
    kz: 'Атқарушы механизмдерді монтаждау',
    en: 'Actuator installation',
  },
  'services.automation.item3': {
    ru: 'Сборка шкафов автоматики',
    kz: 'Автоматика шкафтарын құрастыру',
    en: 'Automation cabinet assembly',
  },
  'services.automation.item4': {
    ru: 'Программирование и настройка ПЛК',
    kz: 'ПЛК бағдарламалау және баптау',
    en: 'PLC programming and configuration',
  },
  'services.automation.item5': {
    ru: 'Интеграция SCADA-систем',
    kz: 'SCADA жүйелерін интеграциялау',
    en: 'SCADA integration',
  },
  'services.automation.item6': {
    ru: 'Пусконаладочные работы',
    kz: 'Іске қосу-баптау жұмыстары',
    en: 'Commissioning works',
  },
  'services.automation.item7': {
    ru: 'Пуск оборудования и сдача в эксплуатацию',
    kz: 'Жабдықты іске қосу және пайдалануға беру',
    en: 'Equipment start-up and handover',
  },

  // Service Category 2: Electrical Installation
  'services.electrical.title': {
    ru: 'Электромонтажные работы (до 1000В)',
    kz: 'Электр монтаж жұмыстары (1000В дейін)',
    en: 'Electrical Installation (Up to 1000V)',
  },
  'services.electrical.item1': {
    ru: 'Силовые сети до 1000В',
    kz: '1000В дейінгі күштік желілер',
    en: 'LV power networks',
  },
  'services.electrical.item2': {
    ru: 'Монтаж ВРУ / ГРЩ',
    kz: 'ВРҚ / ГТҚ монтаждау',
    en: 'Installation of VRU / Main Switchboards',
  },
  'services.electrical.item3': {
    ru: 'Сборка распределительных щитов',
    kz: 'Тарату қалқандарын құрастыру',
    en: 'Distribution panel assembly',
  },
  'services.electrical.item4': {
    ru: 'Прокладка и укладка кабельных линий',
    kz: 'Кабель желілерін төсеу және жаю',
    en: 'Cable routing and laying',
  },
  'services.electrical.item5': {
    ru: 'Подключение технологического оборудования',
    kz: 'Технологиялық жабдықты қосу',
    en: 'Technological equipment connection',
  },

  // Service Category 3: Low-Current Systems
  'services.lowcurrent.title': {
    ru: 'Слаботочные системы',
    kz: 'Әлсіз токты жүйелер',
    en: 'Low-Current Systems',
  },
  'services.lowcurrent.item1': {
    ru: 'Системы пожарной сигнализации (АПС / АПТ / АГПТ)',
    kz: 'Өрт дабылы жүйелері (АПС / АПТ / АГПТ)',
    en: 'Fire alarm systems (APS / APT / AGPT)',
  },
  'services.lowcurrent.item2': {
    ru: 'Системы оповещения и управления эвакуацией (СОУЭ / PAGA)',
    kz: 'Хабарлау және эвакуацияны басқару жүйелері (PAGA)',
    en: 'Public Address & General Alarm (PAGA)',
  },
  'services.lowcurrent.item3': {
    ru: 'Системы видеонаблюдения (CCTV)',
    kz: 'Бейнебақылау жүйелері (CCTV)',
    en: 'CCTV',
  },
  'services.lowcurrent.item4': {
    ru: 'Системы контроля и управления доступом (СКУД)',
    kz: 'Кіруді бақылау және басқару жүйелері (КББЖ)',
    en: 'Access control systems',
  },
  'services.lowcurrent.item5': {
    ru: 'Диспетчеризация инженерных систем',
    kz: 'Инженерлік жүйелерді диспетчерлеу',
    en: 'Engineering systems dispatching',
  },

  // ── EXPERIENCE ──
  'experience.label': {
    ru: 'Опыт специалистов',
    kz: 'Мамандар тәжірибесі',
    en: 'Specialist Experience',
  },
  'experience.heading': {
    ru: 'Опыт ключевых инженерных специалистов',
    kz: 'Негізгі инженерлік мамандардың тәжірибесі',
    en: 'Experience of Key Engineering Specialists',
  },
  'experience.disclaimer': {
    ru: 'Ключевые специалисты, составляющие инженерное ядро компании, ранее принимали участие в реализации проектов на:',
    kz: 'Компанияның инженерлік негізін құрайтын негізгі мамандар бұрын мына нысандарда жобаларды іске асыруға қатысқан:',
    en: 'Key specialists forming the engineering core of the company previously participated in projects at:',
  },
  'experience.note': {
    ru: 'Работы выполнялись в составе подрядных организаций и проектных команд на действующих промышленных объектах.',
    kz: 'Жұмыстар жұмыс істеп тұрған өнеркәсіптік нысандарда мердігерлік ұйымдар мен жобалық топтар құрамында орындалды.',
    en: 'Work was performed as part of contractor organizations and project teams at operating industrial facilities.',
  },
  'experience.scope.title': {
    ru: 'Объём выполненных работ включал:',
    kz: 'Орындалған жұмыстар көлемі:',
    en: 'Scope of work included:',
  },
  'experience.scope.item1': {
    ru: 'Монтаж систем КИПиА',
    kz: 'Бақылау-өлшеу құралдары және автоматика жүйелерін монтаждау',
    en: 'Installation of instrumentation systems',
  },
  'experience.scope.item2': {
    ru: 'Сборка и подключение шкафов управления',
    kz: 'Басқару шкафтарын құрастыру және қосу',
    en: 'Assembly and connection of control cabinets',
  },
  'experience.scope.item3': {
    ru: 'Настройка систем автоматизации',
    kz: 'Автоматтандыру жүйелерін баптау',
    en: 'Automation system configuration',
  },
  'experience.scope.item4': {
    ru: 'Пусконаладочные работы',
    kz: 'Іске қосу-баптау жұмыстары',
    en: 'Commissioning works',
  },
  'experience.scope.item5': {
    ru: 'Испытания и пуск оборудования',
    kz: 'Жабдықты сынау және іске қосу',
    en: 'Testing and equipment start-up',
  },

  // ── FACILITIES ──
  'facilities.label': {
    ru: 'Типовые объекты',
    kz: 'Типтік нысандар',
    en: 'Typical Facilities',
  },
  'facilities.heading': {
    ru: 'Типовые объекты работ',
    kz: 'Типтік жұмыс нысандары',
    en: 'Typical Project Facilities',
  },
  'facilities.industrial.title': {
    ru: 'Промышленные объекты',
    kz: 'Өнеркәсіптік нысандар',
    en: 'Industrial Facilities',
  },
  'facilities.industrial.item1': {
    ru: 'Технологические печи',
    kz: 'Технологиялық пештер',
    en: 'Process furnaces',
  },
  'facilities.industrial.item2': {
    ru: 'Насосные станции',
    kz: 'Сорғы станциялары',
    en: 'Pumping stations',
  },
  'facilities.industrial.item3': {
    ru: 'Котельные установки',
    kz: 'Қазандық қондырғылар',
    en: 'Boiler units',
  },
  'facilities.industrial.item4': {
    ru: 'Производственные линии',
    kz: 'Өндірістік желілер',
    en: 'Production lines',
  },
  'facilities.industrial.item5': {
    ru: 'Обогатительные фабрики',
    kz: 'Байыту фабрикалары',
    en: 'Concentration plants',
  },
  'facilities.construction.title': {
    ru: 'Строительные объекты',
    kz: 'Құрылыс нысандары',
    en: 'Construction Facilities',
  },
  'facilities.construction.item1': {
    ru: 'Жилые комплексы',
    kz: 'Тұрғын үй кешендері',
    en: 'Residential complexes',
  },
  'facilities.construction.item2': {
    ru: 'Бизнес-центры',
    kz: 'Бизнес-орталықтар',
    en: 'Business centers',
  },
  'facilities.construction.item3': {
    ru: 'Складские комплексы',
    kz: 'Қойма кешендері',
    en: 'Warehouse complexes',
  },
  'facilities.construction.item4': {
    ru: 'Промышленные здания',
    kz: 'Өнеркәсіптік ғимараттар',
    en: 'Industrial buildings',
  },

  // ── APPROACH ──
  'approach.label': {
    ru: 'Наш подход',
    kz: 'Біздің тәсіл',
    en: 'Our Approach',
  },
  'approach.heading': {
    ru: 'Принципы работы',
    kz: 'Жұмыс қағидалары',
    en: 'Work Principles',
  },
  'approach.item1': {
    ru: 'Строгое соблюдение проектной документации',
    kz: 'Жобалық құжаттаманы қатаң сақтау',
    en: 'Strict compliance with project documentation',
  },
  'approach.item2': {
    ru: 'Соответствие СНиП, СП РК, ПУЭ',
    kz: 'ҚНжЕ, СП РК, ПУЭ сәйкестігі',
    en: 'Compliance with SNIP, SP RK, PUE',
  },
  'approach.item3': {
    ru: 'Соблюдение требований промышленной безопасности',
    kz: 'Өнеркәсіптік қауіпсіздік талаптарын сақтау',
    en: 'Industrial safety compliance',
  },
  'approach.item4': {
    ru: 'Поэтапный контроль качества',
    kz: 'Кезеңді сапа бақылауы',
    en: 'Stage-by-stage quality control',
  },
  'approach.item5': {
    ru: 'Соблюдение сроков выполнения работ',
    kz: 'Жұмыстарды орындау мерзімдерін сақтау',
    en: 'On-time project execution',
  },
  'approach.item6': {
    ru: 'Прозрачная отчётность перед заказчиком',
    kz: 'Тапсырыс берушіге ашық есептілік',
    en: 'Transparent reporting to client',
  },

  // ── ADVANTAGES ──
  'advantages.label': {
    ru: 'Преимущества',
    kz: 'Артықшылықтар',
    en: 'Advantages',
  },
  'advantages.heading': {
    ru: 'Наши преимущества',
    kz: 'Біздің артықшылықтар',
    en: 'Our Advantages',
  },
  'advantages.item1.title': {
    ru: 'Инженерная специализация',
    kz: 'Инженерлік мамандану',
    en: 'Engineering Specialization',
  },
  'advantages.item1.desc': {
    ru: 'Компания с инженерным фокусом и техническим подходом',
    kz: 'Инженерлік бағыт пен техникалық тәсілі бар компания',
    en: 'Company with engineering focus and technical approach',
  },
  'advantages.item2.title': {
    ru: '35+ лет совокупного опыта',
    kz: '35+ жыл жиынтық тәжірибе',
    en: '35+ Years Combined Expertise',
  },
  'advantages.item2.desc': {
    ru: 'Команда специалистов с многолетним опытом в промышленности',
    kz: 'Өнеркәсіпте көпжылдық тәжірибесі бар мамандар тобы',
    en: 'Team of specialists with years of industrial experience',
  },
  'advantages.item3.title': {
    ru: 'Опыт на крупных предприятиях',
    kz: 'Ірі кәсіпорындардағы тәжірибе',
    en: 'Major Enterprise Experience',
  },
  'advantages.item3.desc': {
    ru: 'Опыт работы на крупных промышленных объектах Казахстана',
    kz: 'Қазақстанның ірі өнеркәсіптік нысандарында жұмыс тәжірибесі',
    en: 'Experience at major industrial facilities in Kazakhstan',
  },
  'advantages.item4.title': {
    ru: 'Гибкость с генподрядчиками',
    kz: 'Бас мердігерлермен икемділік',
    en: 'Flexibility with General Contractors',
  },
  'advantages.item4.desc': {
    ru: 'Гибкие форматы сотрудничества с заказчиками и генподрядчиками',
    kz: 'Тапсырыс берушілер мен бас мердігерлермен ынтымақтастықтың икемді форматтары',
    en: 'Flexible cooperation formats with clients and general contractors',
  },
  'advantages.item5.title': {
    ru: 'Гарантийная поддержка',
    kz: 'Кепілдікті қолдау',
    en: 'Warranty Support',
  },
  'advantages.item5.desc': {
    ru: 'Гарантийное сопровождение выполненных работ',
    kz: 'Орындалған жұмыстарды кепілдікті сүйемелдеу',
    en: 'Warranty support for completed works',
  },
  'advantages.item6.title': {
    ru: 'Технический надзор',
    kz: 'Техникалық қадағалау',
    en: 'Technical Supervision',
  },
  'advantages.item6.desc': {
    ru: 'Возможность осуществления технического надзора на объектах',
    kz: 'Нысандарда техникалық қадағалауды жүзеге асыру мүмкіндігі',
    en: 'Capability to provide technical supervision at facilities',
  },

  // ── COOPERATION ──
  'cooperation.label': {
    ru: 'Формат сотрудничества',
    kz: 'Ынтымақтастық форматы',
    en: 'Cooperation Format',
  },
  'cooperation.heading': {
    ru: 'Форматы сотрудничества',
    kz: 'Ынтымақтастық форматтары',
    en: 'Cooperation Formats',
  },
  'cooperation.item1': {
    ru: 'Работа по договору подряда',
    kz: 'Мердігерлік шарт бойынша жұмыс',
    en: 'Contract-based execution',
  },
  'cooperation.item2': {
    ru: 'Участие в тендерах',
    kz: 'Тендерлерге қатысу',
    en: 'Tender participation',
  },
  'cooperation.item3': {
    ru: 'Генподрядчик / Субподрядчик',
    kz: 'Бас мердігер / Қосалқы мердігер',
    en: 'General Contractor / Subcontractor',
  },
  'cooperation.item4': {
    ru: 'Пусконаладка «под ключ»',
    kz: '«Кілт тапсыру» іске қосу-баптау',
    en: 'Turnkey commissioning',
  },
  'cooperation.item5': {
    ru: 'Техническое сопровождение объектов',
    kz: 'Нысандарды техникалық сүйемелдеу',
    en: 'Technical support of facilities',
  },

  // ── COMPANY STATUS ──
  'status.label': {
    ru: 'Статус компании',
    kz: 'Компания мәртебесі',
    en: 'Company Status',
  },
  'status.heading': {
    ru: 'Статус компании',
    kz: 'Компания мәртебесі',
    en: 'Company Status',
  },
  'status.item1': {
    ru: 'ТОО официально зарегистрировано в Республике Казахстан',
    kz: 'ЖШС Қазақстан Республикасында ресми тіркелген',
    en: 'LLP officially registered in the Republic of Kazakhstan',
  },
  'status.item2': {
    ru: 'Строительная лицензия — в процессе получения',
    kz: 'Құрылыс лицензиясы — алу процесінде',
    en: 'Construction license — in progress',
  },
  'status.item3': {
    ru: 'Расширение материально-технической базы',
    kz: 'Материалдық-техникалық базаны кеңейту',
    en: 'Expanding material-technical base',
  },
  'status.item4': {
    ru: 'Формирование сети поставщиков и партнёров',
    kz: 'Жеткізушілер мен серіктестер желісін қалыптастыру',
    en: 'Building supplier partner network',
  },

  // ── FAQ ──
  'faq.label': {
    ru: 'Частые вопросы',
    kz: 'Жиі қойылатын сұрақтар',
    en: 'FAQ',
  },
  'faq.heading': {
    ru: 'Ответы на частые вопросы',
    kz: 'Жиі қойылатын сұрақтарға жауаптар',
    en: 'Frequently Asked Questions',
  },
  'faq.q1': {
    ru: 'Какие виды работ выполняет компания?',
    kz: 'Компания жұмыстың қандай түрлерін орындайды?',
    en: 'What types of work does the company perform?',
  },
  'faq.a1': {
    ru: 'Мы выполняем работы по промышленной автоматизации и КИПиА, электромонтажные работы до 1000В, а также монтаж слаботочных систем — пожарная сигнализация, видеонаблюдение, СКУД, СОУЭ и диспетчеризация.',
    kz: 'Біз өнеркәсіптік автоматтандыру және КИП және А, 1000В дейінгі электр монтаж жұмыстарын, сондай-ақ әлсіз токты жүйелерді монтаждауды орындаймыз — өрт дабылы, бейнебақылау, КББЖ, PAGA және диспетчерлеу.',
    en: 'We perform industrial automation and instrumentation works, electrical installation up to 1000V, and low-current system installation — fire alarms, CCTV, access control, PAGA, and engineering dispatching.',
  },
  'faq.q2': {
    ru: 'Есть ли у компании строительная лицензия?',
    kz: 'Компанияда құрылыс лицензиясы бар ма?',
    en: 'Does the company have a construction license?',
  },
  'faq.a2': {
    ru: 'Строительная лицензия находится в процессе получения. Компания активно расширяет свою материально-техническую базу и формирует партнёрскую сеть.',
    kz: 'Құрылыс лицензиясы алу процесінде. Компания материалдық-техникалық базасын белсенді кеңейтіп, серіктестік желісін қалыптастыруда.',
    en: 'The construction license is in progress. The company is actively expanding its material-technical base and building a partner network.',
  },
  'faq.q3': {
    ru: 'На каких объектах работали специалисты компании?',
    kz: 'Компания мамандары қандай нысандарда жұмыс істеген?',
    en: 'What facilities have the company specialists worked at?',
  },
  'faq.a3': {
    ru: 'Ключевые специалисты компании ранее участвовали в проектах на объектах 3GP и 3GI (Тенгиз), CNPC-AMG (Актобе), KAZ Minerals (Актогай), GPC (Актобе) в составе подрядных организаций.',
    kz: 'Компанияның негізгі мамандары бұрын мердігерлік ұйымдар құрамында 3GP және 3GI (Теңгіз), CNPC-AMG (Ақтөбе), KAZ Minerals (Ақтоғай), GPC (Ақтөбе) нысандарындағы жобаларға қатысқан.',
    en: 'Key specialists previously participated in projects at 3GP and 3GI (Tengiz), CNPC-AMG (Aktobe), KAZ Minerals (Aktogay), GPC (Aktobe) as part of contractor organizations.',
  },
  'faq.q4': {
    ru: 'В каком формате возможно сотрудничество?',
    kz: 'Ынтымақтастық қандай форматта мүмкін?',
    en: 'What cooperation formats are available?',
  },
  'faq.a4': {
    ru: 'Мы работаем по договору подряда, участвуем в тендерах, выступаем как генподрядчик или субподрядчик, выполняем пусконаладку «под ключ» и обеспечиваем техническое сопровождение объектов.',
    kz: 'Біз мердігерлік шарт бойынша жұмыс істейміз, тендерлерге қатысамыз, бас мердігер немесе қосалқы мердігер ретінде жұмыс істейміз, «кілт тапсыру» іске қосу-баптау орындаймыз және нысандарды техникалық сүйемелдеуді қамтамасыз етеміз.',
    en: 'We work on contract basis, participate in tenders, act as general contractor or subcontractor, perform turnkey commissioning, and provide technical support of facilities.',
  },
  'faq.q5': {
    ru: 'В каких регионах Казахстана работает компания?',
    kz: 'Компания Қазақстанның қандай аймақтарында жұмыс істейді?',
    en: 'In which regions of Kazakhstan does the company operate?',
  },
  'faq.a5': {
    ru: 'Компания работает по всей территории Республики Казахстан. Готовы рассмотреть проекты в любом регионе.',
    kz: 'Компания Қазақстан Республикасының бүкіл аумағында жұмыс істейді. Кез келген аймақтағы жобаларды қарастыруға дайынбыз.',
    en: 'The company operates across the entire Republic of Kazakhstan. We are ready to consider projects in any region.',
  },

  // ── CONTACT ──
  'contact.label': {
    ru: 'Контакты',
    kz: 'Байланыс',
    en: 'Contact',
  },
  'contact.heading': {
    ru: 'Свяжитесь с нами',
    kz: 'Бізбен байланысыңыз',
    en: 'Get in Touch',
  },
  'contact.subtitle': {
    ru: 'Обсудим ваш проект и подготовим коммерческое предложение',
    kz: 'Жобаңызды талқылап, коммерциялық ұсыныс дайындаймыз',
    en: 'Let us discuss your project and prepare a commercial proposal',
  },
  'contact.form.name': {
    ru: 'Имя',
    kz: 'Аты',
    en: 'Name',
  },
  'contact.form.company': {
    ru: 'Компания',
    kz: 'Компания',
    en: 'Company',
  },
  'contact.form.email': {
    ru: 'Email',
    kz: 'Email',
    en: 'Email',
  },
  'contact.form.phone': {
    ru: 'Телефон',
    kz: 'Телефон',
    en: 'Phone',
  },
  'contact.form.message': {
    ru: 'Сообщение',
    kz: 'Хабарлама',
    en: 'Message',
  },
  'contact.form.submit': {
    ru: 'Запросить коммерческое предложение',
    kz: 'Коммерциялық ұсыныс сұрау',
    en: 'Request Commercial Proposal',
  },
  'contact.form.success': {
    ru: 'Заявка отправлена! Мы свяжемся с вами в ближайшее время.',
    kz: 'Өтінім жіберілді! Жақын арада сізбен байланысамыз.',
    en: 'Request sent! We will contact you shortly.',
  },
  'contact.form.error': {
    ru: 'Ошибка при отправке. Пожалуйста, попробуйте ещё раз или свяжитесь по телефону.',
    kz: 'Жіберу кезінде қате. Қайта көріңіз немесе телефон арқылы хабарласыңыз.',
    en: 'Failed to send. Please try again or contact us by phone.',
  },
  'contact.form.sending': {
    ru: 'Отправка...',
    kz: 'Жіберілуде...',
    en: 'Sending...',
  },
  'contact.form.sendAnother': {
    ru: 'Отправить ещё одну заявку',
    kz: 'Тағы бір өтінім жіберу',
    en: 'Send another request',
  },
  'contact.info.director': {
    ru: 'Директор: Еркин Муканов',
    kz: 'Директор: Еркін Мұқанов',
    en: 'Director: Yerkin Mukanov',
  },
  'contact.info.phone': {
    ru: '+7 705 880 66 61',
    kz: '+7 705 880 66 61',
    en: '+7 705 880 66 61',
  },
  'contact.info.email': {
    ru: 'mukanov.yerkin@icloud.com',
    kz: 'mukanov.yerkin@icloud.com',
    en: 'mukanov.yerkin@icloud.com',
  },
  'contact.info.location': {
    ru: 'Республика Казахстан',
    kz: 'Қазақстан Республикасы',
    en: 'Republic of Kazakhstan',
  },
  'contact.info.bin': {
    ru: 'БИН: _______',
    kz: 'БСН: _______',
    en: 'BIN: _______',
  },

  // ── FOOTER ──
  'footer.description': {
    ru: 'Инженерная компания, специализирующаяся на промышленной автоматизации, КИПиА, электромонтажных и строительно-монтажных работах в Казахстане.',
    kz: 'Қазақстанда өнеркәсіптік автоматтандыруға, КИП және А, электр монтаж және құрылыс-монтаж жұмыстарына маманданған инженерлік компания.',
    en: 'Engineering company specializing in industrial automation, instrumentation, electrical installation, and construction works in Kazakhstan.',
  },
  'footer.quicklinks': {
    ru: 'Навигация',
    kz: 'Навигация',
    en: 'Navigation',
  },
  'footer.services': {
    ru: 'Услуги',
    kz: 'Қызметтер',
    en: 'Services',
  },
  'footer.contacts': {
    ru: 'Контакты',
    kz: 'Байланыс',
    en: 'Contact',
  },
  'footer.privacy': {
    ru: 'Политика конфиденциальности',
    kz: 'Құпиялылық саясаты',
    en: 'Privacy Policy',
  },
  'footer.terms': {
    ru: 'Условия использования',
    kz: 'Пайдалану шарттары',
    en: 'Terms of Use',
  },
  'footer.copyright': {
    ru: '© 2025 Power Logic Automation LLP. Все права защищены.',
    kz: '© 2025 Power Logic Automation ЖШС. Барлық құқықтар қорғалған.',
    en: '© 2025 Power Logic Automation LLP. All rights reserved.',
  },
}
